import API from "shared/services/Api";
import { IConfigRepsonse } from "shared/types/Config";

export const getTimeReset = async (): Promise<IConfigRepsonse> =>
  API.get(`public/config`);
